import { FocusableOption } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, ElementRef, inject } from '@angular/core';

@Component({
  selector: '[accredible-menu-item]',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'menuitem',
    tabindex: '0',
    '(keydown.space)': 'onKeydown($event)',
    '(keydown.enter)': 'onKeydown($event)',
  },
})
export class AccredibleMenuItemComponent implements FocusableOption {
  private readonly _element: ElementRef = inject(ElementRef);

  focus(): void {
    this._element.nativeElement.focus();
  }

  onKeydown(event: KeyboardEvent): void {
    if (this._element.nativeElement instanceof HTMLAnchorElement) {
      event.preventDefault();
      this._element.nativeElement.click();
    }
  }
}
